import { ConfigurationWizard } from "@/components/configurations/ConfigurationWizard";

const NewConfiguration = () => {
  return <ConfigurationWizard />;
};

export default NewConfiguration;
